import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { TranslocoModule } from '@jsverse/transloco';
import { merge } from 'lodash';

import { DialogBase, DialogInputText } from '../../../interfaces';
import { InputTextareaComponent } from '../../fields';
import { DialogBaseComponent } from '../dialog-base/dialog-base.component';

@Component({
  selector: 'hmax-dialog-input-text',
  standalone: true,
  templateUrl: './dialog-input-text.component.html',
  styleUrls: ['./dialog-input-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, DialogBaseComponent, InputTextareaComponent, MatDialogModule, TranslocoModule],
})
export class DialogInputTextComponent implements OnInit {
  private data = inject<DialogInputText>(MAT_DIALOG_DATA);
  private _dialogRef = inject(MatDialogRef<DialogInputTextComponent>);
  private _formBuilder = inject(FormBuilder);

  form!: FormGroup;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formControl: any = {
    label: 'reason',
    labelTranslate: true,
    name: 'textArea',
    validators: [Validators.required, Validators.minLength(3), Validators.maxLength(255)],
  };

  constructor() {
    if (this.data?.formControl) {
      this.formControl = { ...this.formControl, ...this.data?.formControl };
    }
  }

  /**
   * Abrir um modal deste componente com as configurações padrão
   * Precisa receber uma instância do MatDialog
   * ex: DialogInputTextComponent.open(this._matDialog);
   * @param matDialog Instância de MatDialog do Angular Material que deve ser injetada
   * pela classe que invocar este método
   */
  static open(matDialog: MatDialog, data?: DialogInputText): MatDialogRef<DialogInputTextComponent> {
    const defaultConfig: DialogBase = {
      actions: {
        confirm: {
          color: 'primary',
          label: 'save',
          labelTranslate: true,
          show: true,
          action: () => dialogRef.componentInstance.save(),
        },
        cancel: {
          label: 'cancel',
          labelTranslate: true,
          show: true,
        },
      },
    };

    const config = merge({}, defaultConfig, data);

    const dialogRef = matDialog.open(DialogInputTextComponent, {
      autoFocus: true,
      data: { matDialog, ...config },
      disableClose: false,
    });

    return dialogRef;
  }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    const formControl = this.formControl;

    this.form = this._formBuilder.group({
      [formControl?.name]: [formControl?.value, formControl?.validators],
    });
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    this._dialogRef.close(this.form?.value);
  }
}
